module.exports = __webpack_public_path__ + "static/img/mdom-course.f84c99b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/personRain/mdom-course.png
// module id = P5dT
// module chunks = 2